var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"min-h-screen container mx-auto flex flex-col gap-y-5 justify-center items-center font-EffraR bg-white py-5"},[_c('policies')],1),_c('dok-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }